import { render, staticRenderFns } from "./HelpComponent.vue?vue&type=template&id=2d34b0a2"
import script from "./HelpComponent.vue?vue&type=script&lang=ts"
export * from "./HelpComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports